module.exports = __webpack_public_path__ + "media/defaults/time-a411aaa0.svg";